<template>
  <section>
    <h6>Radar Feature</h6>
  </section>
</template>

<script>
export default {
  name: 'RadarFeature'
}
</script>

<style></style>
